import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal/Modal';
import Button from '../Button/Button';
import { FaExclamationTriangle } from 'react-icons/fa';
import styles from './ConfirmModal.module.css';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  variant = 'danger',
  isLoading = false,
  showCancelButton = true
}) => {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    } else if (onClose) {
      onClose();
    }
  };

  const handleCancel = () => {
    if (!isLoading && onClose) {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleCancel}
      size="sm"
      closeOnBackdropClick={!isLoading}
      showCloseButton={!isLoading}
    >
      <div className={styles.content}>
        <div className={styles.iconContainer}>
          <FaExclamationTriangle className={styles.icon} />
        </div>
        {title && (
          <h3 className={styles.title}>{title}</h3>
        )}
        {message && (
          <p className={styles.message}>{message}</p>
        )}
        <div className={styles.actions}>
          {showCancelButton && (
            <Button
              variant="ghostOutline"
              onClick={handleCancel}
              disabled={isLoading}
              fullWidth
            >
              {cancelText}
            </Button>
          )}
          <Button
            variant={variant}
            onClick={handleConfirm}
            disabled={isLoading}
            loading={isLoading}
            fullWidth
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'danger', 'success']),
  isLoading: PropTypes.bool,
  showCancelButton: PropTypes.bool,
};

export default ConfirmModal;

